import type { Tokens } from '../augmentation'
import { type ComponentCreation } from './types'

export const createMuiPaper = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: palette.background.paper,
          backgroundImage: 'none',
        },

        outlined: {
          borderColor: palette.dark.light,
        },
      },
    },
  }) satisfies ComponentCreation
